import { IAddAccount } from 'services/rtk/fbmanager/types/account';

export enum FBAccountsActionTypes {
  ADD_NEW_ACCOUNT = 'ADD_NEW_ACCOUNT',
  CHANGE_ACCOUNT = 'CHANGE_ACCOUNT',
  REMOVE_NEW_ACCOUNT = 'REMOVE_NEW_ACCOUNT',
}

export interface INewFBAccount extends IAddAccount {
  key: string;
}

interface IAddNewAccountAction {
  type: FBAccountsActionTypes.ADD_NEW_ACCOUNT;
  payload: INewFBAccount;
}

interface IChangeAccountAction {
  type: FBAccountsActionTypes.CHANGE_ACCOUNT;
  payload: INewFBAccount;
}

interface IRemoveNewAccountAction {
  type: FBAccountsActionTypes.REMOVE_NEW_ACCOUNT;
  payload: string;
}

export type TFBAccountsActions = IAddNewAccountAction | IRemoveNewAccountAction | IChangeAccountAction;

export const addNewFBAccountAction = (payload: INewFBAccount): TFBAccountsActions => ({
  type: FBAccountsActionTypes.ADD_NEW_ACCOUNT,
  payload,
});

export const changeAddedFBAccountAction = (payload: INewFBAccount): TFBAccountsActions => ({
  type: FBAccountsActionTypes.CHANGE_ACCOUNT,
  payload,
});

export const removeNewFBAccountAction = (payload: string): TFBAccountsActions => ({
  type: FBAccountsActionTypes.REMOVE_NEW_ACCOUNT,
  payload,
});
